import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import './styles/fonts.css';
import './styles/index.css';
import './styles/markdown.css'
import './styles/highlight.css'
import './styles/globalStyles.css'

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
